import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './GettingStarted.css';

// Optimized images (you can replace with .webp later)
import apnagharLogo from './apnaghar.png';
import androidPoster from './androidposter.jpg';


import WhyChooseUs from './WhyChooseUs';
import { HeadProvider, Title, Meta, Link } from "react-head";

const GettingStarted = () => {
  const navigate = useNavigate();
  const [showMain, setShowMain] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [cardsVisible, setCardsVisible] = useState([false, false]);
  const [posterLoaded, setPosterLoaded] = useState(false);

  const text = useMemo(() => "ApkaGhr", []);
  const letterDelay = 0.35;

  // Splash screen logic
  useEffect(() => {
    const hasSeenSplash = localStorage.getItem('seenSplash');
    if (hasSeenSplash) {
      setShowMain(true);
      setCardsVisible([true, true]); // show cards immediately
      return;
    }

    const totalDuration = letterDelay * text.length * 1000 + 500;

    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setShowMain(true);
        setCardsVisible([true, true]);
        localStorage.setItem('seenSplash', 'true');
      }, 700);
    }, totalDuration);

    return () => clearTimeout(timer);
  }, [text, letterDelay]);

  const handleStartOptions = () => navigate('/start-options');
  const handleDiscoverHomes = () => navigate('/discover-homes');
  const handleGoHome = () => navigate('/homepage');
  const handleGetStarted = () => navigate('/signin');

  return (
    <HeadProvider>
      {/* SEO */}
      <Title>ApkaGhr | Find PG Rental Homes in Assam</Title>
      <Meta name="description" content="Rent smarter—not harder. Browse verified PGs and rental homes, or list your property and earn. 100% broker-free renting with ApkaGhr." />
      <Meta name="keywords" content="flats for rent in Assam, PG in Gar-Ali Jorhat, room for rent in Assam, PG near engineering college Jorhat, hostel near Jorhat Medical College, zero brokerage rentals Assam, 1BHK 2BHK homes, Assam rental platform, PG in Sivasagar, rooms in Tinsukia" />
      <Meta name="author" content="ApkaGhr Team" />
      <Meta name="viewport" content="width=device-width, initial-scale=1" />
      <Link rel="canonical" href="https://apkaghr.com" />
      <Link rel="icon" type="image/png" href="/apnaghar.png" />
      <Link rel="preload" href={apnagharLogo} as="image" />

      {/* Open Graph / Twitter */}
      <Meta property="og:title" content="ApkaGhr - Rent Homes in Assam" />
      <Meta property="og:description" content="Discover verified homes, PGs, and flats across Assam. 100% broker-free." />
      <Meta property="og:type" content="website" />
      <Meta property="og:image" content="/apnaghar.png" />
      <Meta property="og:url" content="https://www.apkaghr.com" />
      <Meta name="twitter:title" content="ApkaGhr - Assam Rentals" />
      <Meta name="twitter:description" content="Find rental homes and list your property across Assam easily." />
      <Meta name="twitter:image" content="/apnaghar.png" />
      <Meta name="twitter:card" content="summary_large_image" />

      {/* UI */}
      <div className="gs-container">
        {!showMain && (
          <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
            <img
              src={apnagharLogo}
              alt="ApkaGhr Logo"
              className="splash-logo"
              loading="eager"
            />
            <h1 className="animated-text">
              {text.split('').map((char, idx) => (
                <span key={idx} style={{ animationDelay: `${idx * letterDelay}s` }}>
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
            </h1>
          </div>
        )}

        {showMain && (
          <>
            <nav className="gs-navbar">
              <h1 className="gs-logo">
                <img
                  src={apnagharLogo}
                  alt="ApkaGhr Logo"
                  className="gs-navbar-logo"
                  loading="eager"
                />
                ApkaGhr
              </h1>
              <ul className="gs-nav">
                <li><button onClick={handleGoHome}>Home</button></li>
                <li><button onClick={() => navigate('/register')}>Register</button></li>
                <li><button onClick={handleGetStarted}>Sign In</button></li>
              </ul>
            </nav>

            <main className="gs-main">
              <h2 className="gs-heading">Getting Started</h2>
              <p className="gs-subtext">Explore what you can do on ApkaGhr 👇</p>

              {/* Cards */}
              <div className="gs-options">
                <div
                  className={`gs-card modern-card create ${cardsVisible[0] ? "fade-in" : ""}`}
                  onClick={handleStartOptions}
                >
                  <div className="card-icon"></div>
                  <h3>List Your Property or Start Earning</h3>
                  <p>Want to rent out your property? Reach thousands of verified renters easily.</p>
                </div>

                <div
                  className={`gs-card modern-card find ${cardsVisible[1] ? "fade-in" : ""}`}
                  onClick={handleDiscoverHomes}
                >
                  <div className="card-icon"></div>
                  <h3>Explore Homes Before You Join</h3>
                  <p>Browse verified PGs, flats, and homes — even before signing in.</p>
                </div>
              </div>

              {/* CTA Bar */}
              <div className="wcu-cta-box mt-5">
                <h3>Start your rental journey with confidence 🚀</h3>
                <button className="wcu-btn" onClick={handleGetStarted}>
                  Get Started Now
                </button>
              </div>

              {/* Coming Soon Poster */}
             <div className="coming-soon-card">
  <img
    src={androidPoster}
    alt="ApkaGhr App Coming Soon"
    className="coming-soon-img"
  />
  <div className="coming-soon-content">
    <h3>Our App is Coming Soon 🚀</h3>
    <p>We’re building something amazing! Stay tuned for the best rental experience in Assam.</p>
    <button className="gs-button" disabled>Coming Soon 🔒</button>
  </div>
</div>


              {/* WhyChooseUs section */}
              <WhyChooseUs />
            </main>
          </>
        )}
      </div>
    </HeadProvider>
  );
};

export default GettingStarted;

